import { render } from "./CatalogTable.vue?vue&type=template&id=e0230bce"
import script from "./CatalogTable.vue?vue&type=script&lang=js"
export * from "./CatalogTable.vue?vue&type=script&lang=js"
script.render = render

export default script